import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ReportRepositoryImpl } from "../../data/repository/report_repository_impl";
import { ReportInterface } from "../interface/report_interface";

export const useReport = () => {
    const repository = new ReportRepositoryImpl();

    return useMutation<void, AxiosError, ReportInterface>({
        mutationFn: (report) => repository.report(report),
    });
};